import { useTheme } from '@mui/material';

import { colors } from '@constants/colors';
import { ScreenSizes } from '@interfaces';
import { ISwipeableDrawerPosition } from './interfaces';

const horizontalOffsetDesktop = 40;
const verticalOffsetDesktop = 124;

const horizontalOffsetMobile = 20;
const verticalOffsetMobile = 76;

const getPosition = (
  { horizontal, vertical }: ISwipeableDrawerPosition,
  isMobile = false,
) => {
  if (!horizontal || !vertical) return {};

  const horizontalOffset = isMobile
    ? horizontalOffsetMobile
    : horizontalOffsetDesktop;

  const verticalOffset = isMobile
    ? verticalOffsetMobile
    : verticalOffsetDesktop;

  const positionMap = {
    right: { right: horizontalOffset },
    left: { left: horizontalOffset },
    top: { top: verticalOffset },
    bottom: { bottom: verticalOffset },
  };

  return {
    ...positionMap[horizontal],
    ...positionMap[vertical],
    [vertical === 'bottom' ? 'top' : 'bottom']: 'auto',
  };
};

export const useStyles = (position: ISwipeableDrawerPosition) => {
  const { breakpoints } = useTheme();

  return {
    root: {
      position: 'static',
      // Prevent the full-screen Modal root from intercepting pointer events
      // on panels rendered behind it. The Paper retains pointer-events: auto
      // so the drawer itself remains fully interactive.
      pointerEvents: 'none',
      '& .MuiPaper-root': {
        pointerEvents: 'auto',
        backdropFilter: 'blur(12px)',
        backgroundColor: colors.black_99,
        border: '1px solid rgba(255, 255, 255, 0.25)',
        borderRadius: 6,
        height: 'fit-content',
        ...getPosition(position),
        [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
          ...getPosition(position, true),
        },
      },
    },
  };
};
